import ConfirmDialog from '../../components/ConfirmDialog';
import SwitchComponent from '../../components/switch';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import { Avatar, Box, Button, Grid, TextField, Typography, Select, MenuItem, IconButton, FormControl, Rating } from '@mui/material';
import { MerChantModel } from '../../models/merChantModel';
import { MerchantEnum } from '../../enums/merchantEnum';
import { ArrowBack } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { DeliveryFeeModel } from '../../models/deliveryFee';
import { useFormBranchManageControllers } from './controller/form';

interface Props {
  onClose: VoidFunction;
  onfetch: Function
  selectedMerchant: MerChantModel
  selectMerchant: Function
  merchantType: MerchantEnum
}

const FormBranchManage = ({ onClose, onfetch, selectedMerchant, selectMerchant, merchantType }: Props) => {
  const controllers = useFormBranchManageControllers({ onfetch, onClose, selectedMerchant, selectMerchant, merchantType });
  const { t, i18n } = useTranslation("global");


  return (
    <Box>
      <IconButton onClick={() => { onClose(); controllers.handleReset() }}>
        <ArrowBack />
      </IconButton>
      <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
        {
          selectedMerchant ? t('branchManage_page.Update Branch') : t('branchManage_page.Create Branch')
        }
      </Typography>
      <form onSubmit={(e) => controllers.handleOpenForm(e)}>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={6} md={3}>
            <Box
              sx={{
                p: 8,
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                borderRadius: '10px'
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <label htmlFor="image-input-branch">
                  <Avatar
                    alt=""
                    style={{ cursor: 'pointer', width: 120, height: 120, objectFit: 'contain' }}
                    src={controllers.imageToShow}
                  />
                </label>
                <input
                  type="file"
                  id="image-input-branch"
                  onClick={(e: any) => {
                    e.target.value = '';
                  }}
                  onChange={controllers.handleSelectImage}
                  style={{ display: 'none' }}
                />
              </Box>
              <Box mt={2}>
                <Typography textAlign="center">Allowed *.jpeg, *.jpg, *.png</Typography>
                <Typography textAlign="center">Max size of 3.1 MB</Typography>
              </Box>
            </Box>
            {/* {
              selectedMerchant &&
              <> */}

            <Box
              sx={{
                p: 4,
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                borderRadius: '5px',
                mt: 2,
                display: "flex",
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Box>
                <label htmlFor="input-banner-image">
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#EBEBEB',
                      width: 200,
                      height: 80,
                      borderRadius: '10px',
                      cursor: 'pointer',
                    }}
                  >
                    <Box sx={{ position: 'relative', width: '100%', height: '100%', borderRadius: '10px', overflow: 'hidden' }}>
                      <Avatar variant="square"
                        src={controllers.imageBannerToShow as string}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: '#EBEBEB',
                          width: 200,
                          height: 80,
                          borderRadius: '10px',
                          cursor: 'pointer',
                        }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                          <AddIcon style={{ color: TEXT_TITLE_COLOR }} />
                          <Typography color={TEXT_TITLE_COLOR}>{t('masterCategory_page.Add Image')}</Typography>
                        </Box>
                      </Avatar>
                    </Box>
                  </Box>
                </label>
                <input
                  type='file'
                  id='input-banner-image'
                  onClick={(e: any) => {
                    e.target.value = '';
                  }}
                  onChange={controllers.handleSelectBannerImage}
                  style={{ display: 'none' }}
                />
                <Box mt={2}>
                  <Typography textAlign='center'>{t('branchManage_page.Add Banner Branch Image')}</Typography>
                  <Typography textAlign='center' color={TEXT_TITLE_COLOR}>
                    Max size of 3.1 MB
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{ display: 'flex', justifyContent: 'center', mt: 1, alignItems: 'center', gap: 2 }}
            >
              <Typography>
                <span style={{ color: 'red' }}>{t("branchManage_page.InActive")}</span> / <span style={{ color: 'green' }}>{t("branchManage_page.Active")}</span>
              </Typography>
              <SwitchComponent value={controllers.ban} onChange={controllers.onBan} />
            </Box>
            {/* </>
            } */}
            <Box sx={{
              p: 4,
              boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
              borderRadius: '10px',
              mt: 2,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <Box sx={{ marginLeft: 'auto', marginRight: 'auto' }}>
                <Typography>Rating this Merchant</Typography>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  <Rating name="half-rating-read" defaultValue={selectedMerchant?.rate} precision={0.5} readOnly />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={10} md={8}>
            <Box
              sx={{
                p: 4,
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                borderRadius: '10px'
              }}
            >

              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Branch Name English")}</Typography>
                    <TextField fullWidth required inputRef={controllers.nameEn} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Branch Name Laos")}</Typography>
                    <TextField fullWidth required inputRef={controllers.nameLa} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Abbreviate Name")}</Typography>
                    <TextField fullWidth required inputRef={controllers.abbName} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Merchant Code")}</Typography>
                    <TextField fullWidth required inputRef={controllers.merchantCode} disabled={selectedMerchant !== null} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Merchant Number")}</Typography>
                    <TextField fullWidth required inputRef={controllers.merchantNo} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.latitude")}</Typography>
                    <TextField fullWidth required inputRef={controllers.latitude} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.longitude")}</Typography>
                    <TextField fullWidth required inputRef={controllers.longitude} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Province")}</Typography>
                    <TextField fullWidth required inputRef={controllers.province} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.District")}</Typography>
                    <TextField fullWidth required inputRef={controllers.district} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Village")}</Typography>
                    <TextField fullWidth required inputRef={controllers.village} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Phone")}</Typography>
                    <TextField fullWidth required inputRef={controllers.phone} margin='normal' />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Company")}</Typography>
                    <FormControl fullWidth margin='normal'>
                      <Select
                        fullWidth
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={controllers.tabMerchant}
                        onChange={controllers.handleSelectedCompany}
                        style={{ margin: '0' }}
                      >
                        {Object.values(MerchantEnum).map((merchant) => (
                          <MenuItem key={merchant} value={merchant}>
                            {merchant}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{t("branchManage_page.Select Delivery Fee")}</Typography>
                    <FormControl fullWidth margin='normal'>
                      <Select
                        value={controllers.deliveryFeeValue}
                        onChange={controllers.handleSelectDeliveryFee}
                      >
                        {
                          controllers.deliveryFeeData?.map((item: DeliveryFeeModel) => <MenuItem key={item.id} value={item?.id}>{item?.areaName}</MenuItem>)
                        }
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <>
                  {
                    controllers.filterDeliveryFee?.map((data, index) => (
                      <>
                        <Grid item xs={12} sm={6} key={index}>
                          {/* <Box sx={{ width: '100%' }}>
                            <Typography>{t("deliveryFee_page.Area name")}</Typography>
                            <TextField fullWidth value={data?.areaName} margin='normal' />
                          </Box> */}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box sx={{ width: '100%' }}>
                            <Typography>{t("deliveryFee_page.Base delivery Price")}</Typography>
                            <TextField fullWidth value={data?.basePrice} margin='normal' disabled />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box sx={{ width: '100%' }}>
                            <Typography>{t("deliveryFee_page.Extra delivery Price")}</Typography>
                            <TextField fullWidth value={data?.extraPrice} margin='normal' disabled />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box sx={{ width: '100%' }}>
                            <Typography>{t("deliveryFee_page.limit distance")}</Typography>
                            <TextField fullWidth value={data?.limitDistance} margin='normal' disabled />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box sx={{ width: '100%' }}>
                            <Typography>{t("deliveryFee_page.Extra distance")}</Typography>
                            <TextField fullWidth value={data?.extraDistance} margin='normal' disabled />
                          </Box>
                        </Grid>
                      </>
                    ))
                  }
                </>
              </Grid>
              <Box>
                {controllers.errorMessage && <Typography color='error'>{controllers.errorMessage}</Typography>}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, height: 40 }}>
                <Button type='submit' variant="contained" sx={{ textTransform: 'none', width: 150, background: '#11A2F1', borderRadius: '10px' }}>
                  {
                    selectedMerchant ? t('branchManage_page.Update Branch') : t('branchManage_page.Create Branch')
                  }
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <ConfirmDialog
          open={controllers.openConfirm}
          title={`${selectedMerchant ? t('Do you want to update this Data ?') : t('Do you want to create this Data ?')}`}
          loading={controllers.loadingConfirmButton}
          onCancel={controllers.handleCloseConfirm}
          onConfirm={() => controllers.handleSubmit()}
        />
      </form>
    </Box >
  );
};
export default FormBranchManage;
